// GTM STUFF
export const SETTING_GTM_ID = "gtm_id";
export const DEFAULT_GTM_ID = "GTM-F6G6";
// VISUAL WEBSITE OPTIMIZER
export const SETTING_VWO_ID = "vwo_id";
// USER CENTRICS STUFF
export const SETTING_USER_CENTRICS_ID = "uc_id";
export const SETTING_USER_CENTRICS_VERSION = "uc_version";
export const SETTING_USER_CENTRICS_ENABLED = "uc_enabled";

export const SETTINGS_DISABLE_USER_CENTRICS_FOR_CURRENT_PAGE = "turnOffUsercentrics";
export const DEFAULT_USER_CENTRICS_ID = "XF733mG5Z";
// TRACKING PARAMETERS
export const PARAMETER_CHANNEL_ID = "ChannelID";
export const PARAMETER_CAMPAIGN_ID = "CampaignID";
export const PARAMETER_TRANSACTION_ID = "transactionId";
export const PARAMETER_ODER_TRANSACTION_ID = "orderTransactionId";
export const PARAMETER_TRANSACTION_REF_NO = "transactionReferenceNumber";
export const PARAMETER_PAYMENT_TOKEN = "spToken";
export const PARAMETER_FORMDATA = "formData";
export const PARAMETER_TEASER_CONTACT_EMAIL = "teaser_contact_email";
export const HEADER_ONETIME_SECRET = "onetimeSecret";
export const SESSION_KEY_TRANSACTION_DATA = "transactionData";
export const SESSION_KEY_ORDER_TRANSACTION_DATA = "orderTransactionData";
// GLOBAL FACTS SETTINGS
export const SETTING_FACTS_HEADLINE_MAX_LENGTH = "facts.headline.max.length";
export const SETTING_FACTS_MAX_LENGTH = "facts.max.length";
export const SETTING_FACTS_TEASER_TITLE_MAX_LENGTH = "facts.teasertitle.max.length";
// GALLERY SETTINGS
export const SETTING_GALLERY_AUTOPLAY = "gallery.autoplay";
export const SETTING_GALLERY_AUTOPLAY_SPEED = "gallery.autoplay.speed";
export const SETTING_GALLERY_IMAGESLIDE_SPEED = "gallery.imageslide.speed";
// STORYTELLING SETTINGS
export const SETTING_STORYTELLING_TITLE_LENGTH = "storytelling.title.length";
export const SETTING_STORYTELLING_TEXT_LENGTH = "storytellings.text.length";
// QUOTE SETTINGS
export const SETTING_QUOTE_TEXT_LENGTH = "quote.text.length";

export const DEFAULT_DESCRIPTION = "default_description";
// OG STUFF
export const OG_DEFAULT_DESCRIPTION = "og:default_description";
export const OG_DEFAULT_IMAGE = "og:default_image";

// QUICK ACCESS SETTINGS
export const SETTING_QUICK_ACCESS_BUTTON_TARGET = "quick_access_button_target";
export const SETTING_QUICK_ACCESS_BUTTON_CSS_CLASS = "quick_access_button_cssClass";
export const SETTING_QUICK_ACCESS_BUTTON_TEXT = "quick_access_button_text";
// FLYOUT TEASER SETTINGS
export const FLYOUT_TEASER = "flyout_teaser";

function getSetting(settings: any, key: string, defaultValue?: any) {
    if (!settings) {
        return defaultValue ? defaultValue : null;
    } else {
        if (settings[key]) {
            return settings[key];
        } else {
            return defaultValue ? defaultValue : null;
        }
    }
}
export default getSetting